import { AfterViewInit, Directive, ElementRef, HostListener, Input, Optional, Renderer2 } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[smataClientNgAttr]',
  standalone: true
})
export class FormControlAttributeDirective implements AfterViewInit {

  @Input() smataClientNgAttr?: string;

  constructor(
    @Optional() private readonly formControl: NgControl,
    private readonly hostElement: ElementRef,
    private readonly renderer2: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.update();
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.update(value);
  }

  private update(eventValue = '') {
    const el = this.hostElement.nativeElement;

    if (!el) return;

    const controlValue = this.formControl?.control?.value;

    let value = '';

    if (this.formControl?.control?.disabled) {
      value =
        typeof controlValue === 'object' && controlValue !== null
          ? (controlValue as any)?.name ?? ''
          : controlValue ?? '';
    } else {
      value = eventValue;
    }

    this.renderer2.setAttribute(el, 'default-data', value);

    if (this.smataClientNgAttr) {
      this.renderer2.setAttribute(el, 'aria-label', this.smataClientNgAttr);
    }
  }
}
